export function pullRandom(array) {
  const index = Math.floor(Math.random() * array.length);
  return array[index];
}

export function capitalize(string) {
  return string[0].toUpperCase() + string.slice(1);
}

export const luck = [
  'Very Good',
  'Good',
  'Normal',
  'Bad',
  'Very Bad',
];

export const luckVerbs = [
  'Beware',
  'Embrace',
  'Reconsider',
];


export const groups = [
  'family',
  'friends',
  'lovers',
  'enemies',
  'coworkers',
  'authority',
  'animals',
];

export const feelings = [
  'joy',
  'fear',
  'life',
  'death',
];

export const sentenceStarts = [
  'You never know',
  'We all know',
  'Think about',
];


export const fiveWs = [
  'who',
  'what',
  'when',
  'where',
  'why',
  'how',
];

export const pronouns = {
  subject: ['you', 'he', 'she', 'it', 'we', 'you', 'they'],
  object: ['you', 'him', 'her', 'it', 'us', 'you', 'them'],
  possessive: ['your', 'his', 'her', 'it', 'our', 'your', 'their'],
  possessiveAdj: ['yours', 'his', 'hers', 'ours', 'yours', 'theirs'],
  reflexive: ['yourself', 'himself', 'herself', 'itself', 'ourselves', 'yourselves', 'themselves'],
};

export const actions = [
  'mind',
  'embody',
  'accommodate',
  'exceed',
  'pamper',
  'eclipse',
  'transcend',
  'surrender',
  'subdue',
  'vanquish',
  'surpass',
  'dispute',
  'apprehend',
  'believe',
];

export const mids = [
  'will',
  'should',
  'can',
  'cannot',
  'have',
];

export const preposition = [
  'with',
  'at',
  'from',
  'into',
  'during',
  'including',
  'until',
  'against',
  'among',
  'throughout',
  'despite',
  'towards',
  'upon',
  'concerning',
  'of',
  'to',
  'in',
  'for',
  'on',
  'by',
  'about',
  'like',
  'through',
  'over',
  'before',
  'between',
  'after',
  'since',
  'without',
  'under',
  'within',
  'along',
  'following',
  'across',
  'behind',
  'beyond',
  'plus',
  'except',
  'but',
  'up',
  'out',
  'around',
  'down',
  'off',
  'above',
  'near',
];

export const verbs = {
  base: [
    'say',
    'make',
    'go',
    'take',
    'come',
    'see',
    'know',
    'get',
    'give',
    'find',
    'think',
    'tell',
    'become',
    'show',
    'leave',
    'feel',
    'bring',
    'begin',
    'keep',
    'hold',
    'write',
    'stand',
    'hear',
    'let',
    'mean',
    'set',
    'meet',
    'sit',
    'speak',
    'lie',
    'grow',
    'lose',
    'fall',
    'send',
    'build',
    'understand',
    'break',
    'cut',
    'rise',
    'choose',
  ],
  past: [
    'said',
    'made',
    'went',
    'took',
    'came',
    'saw',
    'knew',
    'got',
    'gave',
    'found',
    'thought',
    'told',
    'became',
    'showed',
    'left',
    'felt',
    'put',
    'brought',
    'began',
    'kept',
    'held',
    'wrote',
    'stood',
    'heard',
    'let',
    'meant',
    'set',
    'met',
    'ran',
    'paid',
    'sat',
    'spoke',
    'lay',
    'led',
    'read',
    'grew',
    'lost',
    'fell',
    'sent',
    'built',
    'understood',
    'drew',
    'broke',
    'spent',
    'cut',
    'rose',
    'drove',
    'bought',
    'wore',
    'chose',
  ],
  pastParticiple: [
    'said',
    'made',
    'gone',
    'taken',
    'come',
    'seen',
    'known',
    'got',
    'given',
    'found',
    'thought',
    'told',
    'become',
    'shown',
    'left',
    'felt',
    'put',
    'brought',
    'begun',
    'kept',
    'held',
    'written',
    'stood',
    'heard',
    'let',
    'meant',
    'set',
    'met',
    'run',
    'paid',
    'sat',
    'spoken',
    'lain',
    'led',
    'read',
    'grown',
    'lost',
    'fallen',
    'sent',
    'built',
    'understood',
    'drawn',
    'broken',
    'spent',
    'cut',
    'risen',
    'driven',
    'bought',
    'worn',
    'chosen',
  ],
};

export const nouns = {
  person: [
    'adult',
    'baby',
    'child',
    'boy',
    'family',
    'girl',
    'loved one',
    'man',
    'mother',
    'mister',
    'people',
    'person',
    'stranger',
    'woman',
  ],
  place: [
    'country',
    'galaxy',
    'home',
    'ocean',
    'room',
    'sea',
    'space',
    'world',
  ],
  thing: [
    'book',
    'case',
    'company',
    'eye',
    'hand',
    'money',
    'knife',
    'planet',
    'program',
    'system',
    'thing',
    'water',
    'world',
  ],
  idea: [
    'business',
    'day',
    'fact',
    'life',
    'love',
    'month',
    'night',
    'number',
    'point',
    'problem',
    'question',
    'right',
    'story',
    'time',
    'week',
    'work',
    'wealth',
    'happiness',
    'pride',
    'fear',
    'belief',
  ],
};

export const determiners = [
  'the',
  'another',
  'no',
  'some',
  'any',
  'our',
  'their',
  'its',
  'each',
  'every',
  'certain',
  'this',
  'that',
];

export const times = [
  'right now',
  'tomorrow',
  'soon',
  'immediately',
  'later',
  'now',
  'this year',
  'this week',
  'today',
];



// WEBPACK FOOTER //
// ./src/groups.js